import levels from "./data-levels.js"
import Level from "./Level.js"
import C from "./constants.js"

export default () => ({
	open: false,
	score: 0,
	bonus: 0,
	messageList: [],
	state: 'ready',
	levels: levels,

	init() {
		this.drawPreview = C.drawPreview
		this.level = new Level(this.levels[0]);
		this.setCSSVariables()
		this.state = 'ready';

	},
	setCSSVariables() {
		let root = document.querySelector(':root');
		let style = window.getComputedStyle(root)
		this.cellSize = parseInt(style.getPropertyValue('--cellSize'));
		// root.style.setProperty('--cellSize', `${this.cellSize}px`);
		root.style.setProperty('--gridCols', C.columns);
		root.style.setProperty('--gridRows', C.rows);
		root.style.setProperty('--flowTime', `${C.flowSpeed}s`);
		root.style.setProperty('--timerDur', `${C.countdownDuration}s`);
		root.style.setProperty('--numNextTiles', `${C.drawPreview}`);
	},
	startGame() {
		this.open = true
		this.startTimer()
	},
	startTimer() {
		this.state = 'countdown'
	},
	onTimerEnd() {
		this.level.grid.startingCell.tile.startFlow()
	},


	completeCell(cell) {
		if (cell.tile.type == 'end') {
			console.log('Made it to the end')
			this.onSuccess()
			return
		}
		let nextCell = this.level.grid.getNextCell(cell);
		if (nextCell && nextCell.tile && nextCell.tile.checkStartFlow(cell.tile.out)) {
			nextCell.tile.startFlow(cell.tile.out)
		} else {
			console.log('donezo')
			if (!this.level.distanceRemaining) {
				this.onSuccess()
			} else {
				this.onFail()
			}
		}
	},
	onFail() {
		let endCells = this.level.grid.cells.filter(cell => cell.tile && !cell.locked)
		for (let i = 0; i < endCells.length; i++) {
			setTimeout(() => {
				endCells[i].destroyTile()
			}, i * 150);
		}
		setTimeout(() => {
			this.open = false;
			this.level = new Level(levels[this.level.id-1]);
			this.state = 'ready';
		}, 1000);



	},
	onSuccess() {
		// destroy leftovers
		let endCells = this.level.grid.cells.filter(cell => cell.tile && !cell.locked)
		for (let i = 0; i < endCells.length; i++) {
			setTimeout(() => {
				endCells[i].destroyTile()
			}, i * 150);
		}

		setTimeout(() => {
			this.open = false;
			this.level = new Level(levels[this.level.id]);
			this.state = 'ready';
		}, 2500);

		setTimeout(() => {
			this.open = true;
			this.startTimer()
		}, 4500)

		//update score
		//stop flow music
		//start enc
		//ui to continue to next level
		//ui to retry
	}
})

